import { createContext, useContext } from 'react';

const BrandContext = createContext(null);

export function BrandProvider({ children, brandConfig, logo }) {
  return <BrandContext.Provider value={{ brandConfig, logo }}>{children}</BrandContext.Provider>;
}

export function useBrand() {
  const context = useContext(BrandContext);
  if (!context) {
    throw new Error('useBrand must be used within a BrandProvider');
  }
  return context;
}
